import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  // There are a few cases where you give a component an attribute, such as when you want to augment a built-in element. e.g. in this case <ul> | <ol> this will never be used on custom elements. spoke w/ Tom Stone and we're going to trial.
  // https://angular.io/guide/styleguide#style-05-03
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[rma-list]',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    '[attr.role]': "'list'",
  },
})
export class ListComponent {}
